// Module
var code = `<div ng-switch="\$ctrl.link">
  <div ng-switch-when="NA|NULL" ng-switch-when-separator="|"></div>
  <div ng-switch-when="modal" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.openModal()" class="{{\$ctrl.btnclass}} mt-0">{{\$ctrl.text}}<i class="mrs-icon mrs-arrow-right-long ms-2 {{\$ctrl.arrow}}"></i></button>
  </div>
  <div ng-switch-when="disabled" class="{{\$ctrl.align}}">
    <button type="button" disabled class="{{\$ctrl.btnclass}} mt-0">{{\$ctrl.text}}<i class="mrs-icon mrs-arrow-right-long ms-2 {{\$ctrl.arrow}}"></i></button>
  </div>
  <div ng-switch-when="optin" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.optin(\$event)" class="{{\$ctrl.btnclass}} mt-0">{{\$ctrl.text}}<i class="mrs-icon mrs-arrow-right-long ms-2 {{\$ctrl.arrow}}"></i></button>
  </div>
  <div ng-switch-when="onclick" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.onClick()" class="{{\$ctrl.btnclass}} mt-0">{{\$ctrl.text}}<i class="mrs-icon mrs-arrow-right-long ms-2 {{\$ctrl.arrow}}"></i></button>
  </div>
  <div ng-switch-when="scroll" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.scrollTo(\$ctrl.target)" class="{{\$ctrl.btnclass}} mt-0">{{\$ctrl.text}}<i class="mrs-icon mrs-arrow-right-long ms-2 {{\$ctrl.arrow}}"></i></button>
  </div>
  <a ng-switch-default ng-href="{{\$ctrl.AppService.cta(\$ctrl.link)}}" class="{{\$ctrl.btnclass}} mt-0" target="{{\$ctrl.target}}">{{\$ctrl.text}}<i class="mrs-icon mrs-arrow-right-long ms-2 {{\$ctrl.arrow}}"></i></a>
</div>`;
// Exports
export default code;